import { DirectoryProperty } from '@centecomm/portal-service';
import { useDirectory } from '@centecomm/portal-service-react';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { LoadStatus } from '../../../Types';
import { DirectoryActions, DirectoryActionTypes } from '../actions';
import * as selectors from '../selectors';

type DirectoryStateHook = () => {
    areLoaded: boolean;
    areLoading: boolean;
    hasError: boolean;
    loadState: LoadStatus;
};

export const usePropertiesFromDirectoryState: DirectoryStateHook = () => {
    const dispatch = useDispatch();

    const { getDirectoryProperties } = useDirectory();

    const loadState: LoadStatus = useSelector(selectors.propertiesLoadStatus);

    React.useEffect(() => {
        if (loadState === LoadStatus.INITIAL_STATE || loadState === LoadStatus.ERROR) {
            dispatch({
                type: DirectoryActions.LOAD_PROPERTIES,
            });

            getDirectoryProperties()
                .then((properties: DirectoryProperty[]) => {
                    dispatch({
                        type: DirectoryActions.SET_PROPERTIES,
                        payload: properties.map(
                            ({ id, name, occupants }) =>
                                ({
                                    id,
                                    name,
                                    occupants: occupants.map(({ id, name, phone, associated }) => ({
                                        id,
                                        name,
                                        phone,
                                        associated,
                                    })),
                                } as DirectoryProperty),
                        ),
                    } as DirectoryActionTypes);
                })
                .catch((error) => {
                    dispatch({
                        type: DirectoryActions.SET_PROPERTIES_ERROR_STATE,
                        payload: {
                            errorMessage: !!error?.code ? error.code : 'We were not able to load properties.',
                        },
                    });
                });
        }
    }, [loadState]);

    return {
        areLoaded: loadState === LoadStatus.LOADED,
        areLoading: loadState === LoadStatus.PENDING,
        hasError: loadState === LoadStatus.ERROR,
        loadState,
    };
};
